import { useCustomSnackbar } from '@amagimedia/amagi-design-system/src';
import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { getBlipConfig, IBlipConfig } from '../apis/blip';

export const useGetBlipConfig = (
  channelId: number,
  accountDomain: string,
): UseQueryResult<AxiosResponse<IBlipConfig>, unknown> => {
  const showSnackbar = useCustomSnackbar();

  return useQuery(
    ['blip-config', accountDomain, channelId],
    () => getBlipConfig(accountDomain, channelId),
    {
      onError() {
        showSnackbar('Something went wrong while loading blip config', 'error');
      },
    },
  );
};
